import { render, staticRenderFns } from "./NewCalorimetryPartTwo.vue?vue&type=template&id=4dd6eca9&"
import script from "./NewCalorimetryPartTwo.vue?vue&type=script&lang=js&"
export * from "./NewCalorimetryPartTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports